<template>
  <transition name="fade">
    <div class="filter-menu" :class="dark_mode ? 'dark' : ''" @mouseover="mouseoverSidemenu()" @mouseleave="mouseleaveSidemenu()">
      <div class="filter-title" :class="dark_mode ? 'dark' : ''">
        リスト内フィルター
        <span style="padding: 5px; font-size:16px" class="pointer" @click="filterClose()">
          <font-awesome-icon :icon="['fal', 'times']" />
        </span>
      </div>
      <div class="filter-wrap" :class="[dark_mode ? 'dark' : '']">
        <div v-if="sns_type == 'instagram'">
          <div class="side-search-form-box">
            <div class="filter-wrap-title">性別</div>
            <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
              <div class="side-search-form-radio" style="margin-bottom:0px">
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_female" @change="filterList()">女性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_male" @change="filterList()">男性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_other" @change="filterList()">
                  その他
                </el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="filter.gender_null" @change="filterList()"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">フォロワー数</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.followers"
              @change="filterList()"
              :step="5000"
              name="follower"
              :marks="follower_marks"
              range
              :max="500000"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">EGR</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.average_engagement_rate"
              @change="filterList()"
              :step="0.5"
              name="egr"
              :marks="average_engagement_rate_marks"
              range
              :max="10"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">フォロワー女性比率</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.female_ratio"
              @change="filterList()"
              :step="5"
              name="gender"
              :marks="female_ratio_marks"
              range
              :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box">
            <div class="filter-wrap-title">年齢</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.age"
              @change="filterList()"
              :step="5"
              name="gender"
              :marks="age_marks"
              range
              :min="15"
              :max="55"
              :format-tooltip="ageTooltip"
            ></el-slider>
          </div>
          <!-- PR率（Instagram） -->
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">PR率</div>
            <el-slider
                class="side-filter-slider"
                :class="dark_mode ? 'dark' : ''"
                v-model="filter.pr_rate"
                @change="filterList()"
                :step="1"
                name="pr_rate"
                :marks="pr_rate_marks"
                range
                :min="0"
                :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow_m">
            <div class="filter-wrap-title">
              関連エリア
            </div>
            <el-cascader
              v-model="filter.area"
              :options="sidemenu_option.area_list"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="エリア選択"
              collapse-tags
              clearable
              @change="filterList()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
            ></el-cascader>
          </div>
          <div class="side-search-form-box narrow_m">
            <div class="filter-wrap-title">
              関連カテゴリ
            </div>
            <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="filter.category" @change="filterList()" style="margin-left: 0px;" placeholder="カテゴリ選択" size="mini">
              <el-option v-for="item in sidemenu_option.category_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="sns_type == 'youtube'">
          <div class="side-search-form-box">
            <div class="filter-wrap-title">性別</div>
            <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
              <div class="side-search-form-radio youtube" style="margin-bottom:0px">
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_female" @change="filterList()">女性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_male" @change="filterList()">男性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_group" @change="filterList()">グループ</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_other" @change="filterList()">
                  その他
                  <el-tooltip placement="top">
                    <div slot="content">その他: 番組、漫画、キャラクター、動物、ブランド・企業公式チャンネルなど</div>
                    <span>
                      <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
                    </span>
                  </el-tooltip>
                </el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="filter.gender_null" @change="filterList()"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">チャンネル登録者数</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.subscriber"
              @change="filterList()"
              :disabled="activate < 10"
              :step="5000"
              name="follower"
              :marks="follower_marks"
              range
              :max="500000"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">視聴率</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.viewRate"
              @change="filterList()"
              :disabled="activate < 10"
              :step="10"
              name="viewRate"
              :marks="viewRate_marks"
              range
              :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">EGR</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.average_engagement_rate"
              @change="filterList()"
              :disabled="activate < 10"
              :step="1"
              name="average_engagement_rate"
              :marks="average_engagement_rate_marks"
              range
              :max="10"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">チャンネル登録者女性比率</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.female_ratio"
              @change="filterList()"
              :step="5"
              name="gender"
              :marks="female_ratio_marks"
              range
              :max="100"
            ></el-slider>
          </div>
          <!-- PR率（YouTube） -->
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">PR率（長尺）</div>
            <el-slider
                class="side-filter-slider"
                :class="dark_mode ? 'dark' : ''"
                v-model="filter.prRate_long_3month"
                @change="filterList()"
                :step="1"
                name="prRate_long_3month"
                :marks="pr_rate_marks"
                range
                :min="0"
                :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">PR率（ｼｮｰﾄ動画）</div>
            <el-slider
                class="side-filter-slider"
                :class="dark_mode ? 'dark' : ''"
                v-model="filter.prRate_short_3month"
                @change="filterList()"
                :step="1"
                name="prRate_short_3month"
                :marks="pr_rate_marks"
                range
                :min="0"
                :max="100"
            ></el-slider>
          </div>
        </div>
        <div v-if="sns_type == 'tiktok'">
          <div class="side-search-form-box">
            <div class="filter-wrap-title">性別</div>
            <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
              <div class="side-search-form-radio youtube" style="margin-bottom:0px">
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_female" @change="filterList()">女性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_male" @change="filterList()">男性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_group" @change="filterList()">グループ</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_other" @change="filterList()">
                  その他
                  <el-tooltip placement="top">
                    <div slot="content">その他: 番組、漫画、キャラクター、動物、ブランド・企業公式チャンネルなど</div>
                    <span>
                      <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
                    </span>
                  </el-tooltip>
                </el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="filter.gender_null" @change="filterList()"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">フォロワー数</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.subscriber"
              @change="filterList()"
              :disabled="activate < 10"
              :step="5000"
              name="follower"
              :marks="follower_marks"
              range
              :max="500000"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">総いいね数</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.heartCount"
              @change="filterList()"
              :disabled="activate < 10"
              :step="10000"
              name="follower"
              :marks="heart_marks"
              range
              :max="5000000"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">EGR</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.average_engagement_rate"
              @change="filterList()"
              :disabled="activate < 10"
              :step="1"
              name="average_engagement_rate"
              :marks="average_engagement_rate_marks"
              range
              :max="10"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">フォロワー女性比率</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.female_ratio"
              @change="filterList()"
              :step="5"
              name="gender"
              :marks="female_ratio_marks"
              range
              :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">視聴率</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.viewRate"
              @change="filterList()"
              :disabled="activate < 10"
              :step="10"
              name="viewRate"
              :marks="viewRate_marks"
              range
              :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">PR率</div>
            <el-slider
                class="side-filter-slider"
                :class="dark_mode ? 'dark' : ''"
                v-model="filter.pr_rate"
                @change="filterList()"
                :step="1"
                name="pr_rate"
                :marks="pr_rate_marks"
                range
                :min="0"
                :max="100"
            ></el-slider>
          </div>
        </div>
        <div v-if="sns_type == 'twitter'">
          <div class="side-search-form-box">
            <div class="filter-wrap-title">性別</div>
            <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
              <div class="side-search-form-radio youtube" style="margin-bottom:0px">
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_female" @change="filterList()">女性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_male" @change="filterList()">男性</el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.gender_other" @change="filterList()">
                  その他
                  <el-tooltip placement="top">
                    <div slot="content">その他: 番組、漫画、キャラクター、動物、ブランド・企業公式チャンネルなど</div>
                    <span>
                      <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
                    </span>
                  </el-tooltip>
                </el-checkbox>
                <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="filter.gender_null" @change="filterList()"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">フォロワー数</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.subscriber"
              @change="filterList()"
              :disabled="activate < 10"
              :step="5000"
              name="follower"
              :marks="follower_marks"
              range
              :max="500000"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">EGR</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.average_engagement_rate"
              @change="filterList()"
              :disabled="activate < 10"
              :step="1"
              name="average_engagement_rate"
              :marks="average_engagement_rate_marks"
              range
              :max="10"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">投稿頻度(週次)</div>
            <el-slider
              class="side-filter-slider"
              :class="dark_mode ? 'dark' : ''"
              v-model="filter.frequency"
              @change="filterList()"
              :disabled="activate < 10"
              :step="1"
              name="frequency"
              :marks="frequency_marks"
              range
              :max="50"
            ></el-slider>
          </div>
          <!-- PR率（X） -->
          <div class="side-search-form-box narrow">
            <div class="filter-wrap-title">PR率</div>
            <el-slider
                class="side-filter-slider"
                :class="dark_mode ? 'dark' : ''"
                v-model="filter.pr_rate"
                @change="filterList()"
                :step="1"
                name="pr_rate"
                :marks="pr_rate_marks"
                range
                :min="0"
                :max="100"
            ></el-slider>
          </div>
          <div class="side-search-form-box narrow_m">
            <div class="filter-wrap-title">
              関連カテゴリ
            </div>
            <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="filter.category" @change="filterList()" style="margin-left: 0px;" placeholder="カテゴリ選択" size="mini">
              <el-option v-for="item in sidemenu_option.category_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="side-search-form-box narrow_m" v-if="sns_type == 'instagram' || sns_type == 'youtube'">
          <div class="filter-wrap-title">
            フォロワー年齢層
          </div>
          <el-select
            clearable
            class="sidemenu-input"
            :class="dark_mode ? 'dark' : ''"
            v-model="filter.main_audience"
            @change="filterList()"
            style="margin-left: 0px;"
            placeholder="フォロワーの年齢層"
            size="mini"
          >
            <el-option label="13-17" value="13_17"></el-option>
            <el-option label="18-24" value="18_24"></el-option>
            <el-option label="25-34" value="25_34"></el-option>
            <el-option label="35-44" value="35_44"></el-option>
            <el-option label="45-54" value="45_54"></el-option>
            <el-option label="55-64" value="55_64"></el-option>
          </el-select>
          <el-slider
            v-if="filter.main_audience.match(/\_/)"
            style="margin-top:5px"
            class="side-filter-slider"
            :class="dark_mode ? 'dark' : ''"
            v-model="filter.main_audience_percent"
            @change="filterList()"
            :step="5"
            name="gender"
            :marks="female_ratio_marks"
            range
            :max="100"
          ></el-slider>
        </div>
        <div class="side-search-form-box narrow_m" v-if="!master">
          <div class="filter-wrap-title">
            ステータス
          </div>
          <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="filter.status" @change="filterList()" style="margin-left: 0px;" placeholder="ステータス選択" size="mini">
            <el-option v-for="item in status_list" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="side-search-form-box narrow" v-if="!master">
          <div class="filter-wrap-title">
            コメント
          </div>
          <el-input
            v-model="filter.comment"
            :disabled="filter.commentNull"
            placeholder="検索キーワードを入力"
            :trigger-on-focus="false"
            @input="filterList()"
            clearable
            class="side-search-form-input"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
          ></el-input>
          <div class="side-search-form-radio">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="filter.commentNull" @change="filterList()">コメント未入力のみを表示</el-checkbox>
          </div>
        </div>
        <div class="side-search-form-box narrow_m">
          <div class="filter-wrap-title">
            カスタマイズタグ
          </div>
          <sidemenuCustomizeTag :sns_type="'filter'" @filterList="filterList" :filter.sync="filter" />
        </div>
        <div class="side-search-form-box">
          <div class="filter-wrap-title">数値</div>
          <el-slider class="side-filter-slider" :class="dark_mode ? 'dark' : ''" v-model="filter.num" @change="filterList()" :step="1" name="num" :marks="num_marks" range :max="100"></el-slider>
        </div>
        <div class="side-search-form-box narrow_m">
          <div class="filter-wrap-title">
            以下の投稿を含む
          </div>
          <el-input
            v-model="filter.post_keyword"
            placeholder="検索キーワードを入力"
            :trigger-on-focus="false"
            @input="filterList()"
            clearable
            class="side-search-form-input"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
          ></el-input>
          <div v-if="filter.post_keyword" :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-top: 10px;">
            <div class="filter-wrap-title" style="font-weight: 400">
              投稿件数でさらに絞り込む
            </div>
            <div style="margin-top: 10px;">
              <div class="side-filter-post-slider-wrap">
                <div class="side-filter-post-subtitle">
                  <el-radio @change="filterList()" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_type" label="range">投稿件数を指定</el-radio>
                </div>
                <div v-if="filter.post_option_type == 'range'" :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-top: 10px;">
                  <el-slider
                    class="side-filter-slider"
                    :class="dark_mode ? 'dark' : ''"
                    v-model="filter.post_count"
                    @change="filterList()"
                    :step="1"
                    name="follower"
                    :marks="post_count_marks"
                    range
                    :min="1"
                    :max="10"
                    size="mini"
                  ></el-slider>
                </div>
              </div>
              <div class="side-filter-post-slider-wrap" style="margin-bottom: 0px;">
                <div class="side-filter-post-subtitle">
                  <el-radio @change="filterList()" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_type" label="criteria">設定値で指定</el-radio>
                  <el-tooltip placement="top-start" content="各インフルエンサーに設定された数値を指定件数として絞り込みます">
                    <font-awesome-icon :icon="['fas', 'question-circle']" />
                  </el-tooltip>
                </div>
                <div v-if="filter.post_option_type == 'criteria'" :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-top: 10px;">
                  <div class="side-filter-post-criteria">
                    <el-radio @change="filterList()" class="side-filter-post-criteria-radio" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_criteria" label="ormore">設定値以上</el-radio>
                    <el-radio @change="filterList()" class="side-filter-post-criteria-radio" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_criteria" label="orless">設定値以下</el-radio>
                    <el-radio @change="filterList()" class="side-filter-post-criteria-radio" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_criteria" label="equal"
                      >設定値と同じ</el-radio
                    >
                    <el-radio @change="filterList()" class="side-filter-post-criteria-radio" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_criteria" label="more"
                      >設定値より大きい</el-radio
                    >
                    <el-radio @change="filterList()" class="side-filter-post-criteria-radio" :class="dark_mode ? 'dark' : ''" v-model="filter.post_option_criteria" label="less"
                      >設定値より小さい</el-radio
                    >
                  </div>
                  Ω
                </div>
              </div>
            </div>
          </div>
          <div v-if="filter.post_keyword" :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-top: 10px;">
            <div class="filter-wrap-title" style="font-weight: 400">
              投稿期間でさらに絞り込む
            </div>
            <div style="margin-top: 5px;">
              <div class="filter-date">
                <el-date-picker
                  @change="filterList()"
                  :class="dark_mode ? 'dark' : ''"
                  v-model="filter.post_daterange"
                  type="daterange"
                  placeholder="から"
                  format="yyyy/MM/dd"
                  value-format="timestamp"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                  start-placeholder="from"
                  end-placeholder="to"
                  size="mini"
                ></el-date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="side-search-form-box narrow">
          <div class="filter-wrap-title">レポート実績有無</div>
          <el-radio-group v-model="filter.report_record_status" size="mini" @change="filterList()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="0">
              -
            </el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">
              有
            </el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">
              無
            </el-radio>
          </el-radio-group>
        </div>

        <div class="side-search-form-box narrow">
          <div class="filter-wrap-title">
            レポート名
          </div>
          <el-input
            v-model="filter.report_keyword"
            :disabled="filter.commentNull"
            placeholder="レポート名に含まれるキーワード"
            :trigger-on-focus="false"
            @input="filterList()"
            clearable
            class="side-search-form-input"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
          ></el-input>
        </div>

        <div class="side-search-form-button unset" :class="dark_mode ? 'dark' : ''">
          <el-button @click="reset()" style="margin-right:10px;" :type="dark_mode ? 'info' : 'default'" :class="dark_mode ? 'dark' : ''" size="mini">リセット</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import sidemenuCustomizeTag from "../sidemenu/sidemenu_customize_tag.vue";

export default {
  name: "listFilter",
  props: ["filter_show", "filter", "sns_type", "master"],
  components: {
    sidemenuCustomizeTag,
  },
  data() {
    return {
      filter_item: "",
      filtered: false,
      sort_order: "ormore",
      filter_initial: {
        sns_type: this.sns_type,
        radio: 1,
        gender_female: true,
        gender_male: true,
        gender_other: true,
        gender_group: true,
        gender_null: false,
        followers: [0, 500000],
        heartCount: [0, 5000000],
        average_engagement_rate: [0, 10],
        female_ratio: [0, 100],
        age: [15, 55],
        subscriber: [0, 500000],
        viewRate: [0, 100],
        frequency: [0, 50],
        comment: "",
        commentNull: false,
        num: [0, 100],
        post_keyword: "",
        post_count: [1, 10],
        post_option_type: "range",
        post_option_criteria: "ormore",
        post_daterange: "",
        area: "",
        status: "",
        category: "",
        tags: [],
        main_audience: "",
        main_audience_percent: [0, 100],
        report_record_status: 0,
        report_keyword: "",
        pr_rate: [0, 100],
        prRate_long_3month: [0, 100],
        prRate_short_3month: [0, 100],
      },
      status_list: ["未設定", "承諾", "確認中", "完了", "NG"],
      follower_marks: {
        500000: "500K+",
      },
      heart_marks: {
        5000000: "5M+",
      },
      female_ratio_marks: {
        100: "100%",
      },
      age_marks: {
        55: "55+",
      },
      average_engagement_rate_marks: {
        10: "10%+",
      },
      engagement_marks: {
        10000: "10K+",
      },
      viewRate_marks: {
        100: "100%+",
      },
      post_count_marks: {
        10: "10+",
      },
      num_marks: {
        100: "100",
      },
      frequency_marks: {
        50: "50+",
      },
      pr_rate_marks: { 100: "100%" },
    };
  },
  computed: {
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    sidemenu_option() {
      return this.$store.state.sidemenu_option;
    },
    pickerOptions() {
      var dt = new Date();
      return {
        disabledDate(time) {
          return time.getTime() > dt;
        },
      };
    },
    // pickerOptionsEnd() {
    //   var start_at = this.filter.post_start_at;
    //   var dt = new Date();
    //   return {
    //     disabledDate(time) {
    //       var start = new Date(start_at);
    //       return start > time.getTime() || time.getTime() > dt ;
    //     },
    //   };
    // },
  },
  created() {
    if (this.filter == "") {
      var filter = Object.assign({}, this.filter_initial);
      this.$emit("update:filter", filter);
    }
    if (!Array.isArray(this.filter.pr_rate) || this.filter.pr_rate.length !== 2) {
      this.$set(this.filter, 'pr_rate', [0, 100]);
    }
    if (!Array.isArray(this.filter.prRate_long_3month) || this.filter.prRate_long_3month.length !== 2) {
      this.$set(this.filter, 'prRate_long_3month', [0, 100]);
    }
    if (!Array.isArray(this.filter.prRate_short_3month) || this.filter.prRate_short_3month.length !== 2) {
      this.$set(this.filter, 'prRate_short_3month', [0, 100]);
    }
  },
  mounted() {},
  methods: {
    filterList() {
      if (this.filter.commentNull) {
        this.filter.comment = "";
      }
      if (JSON.stringify(this.filter) == JSON.stringify(this.filter_initial)) {
        this.filtered = false;
      } else {
        this.filtered = true;
      }
      this.$emit("update:filter", this.filter);
      this.$emit("filterList", this.filtered);
    },
    reset() {
      this.filter = Object.assign({}, this.filter_initial);
      this.filterList();
    },
    filterClose() {
      this.$emit("filterClose", false);
    },
    mouseoverSidemenu() {
      document.documentElement.style.overflow = "hidden";
    },
    mouseleaveSidemenu() {
      document.documentElement.style.overflow = "auto";
    },
    ageTooltip(val) {
      if (val == 55) {
        return val + "+";
      } else if (val == 15) {
        return "〜" + val;
      } else {
        return val;
      }
    },
  },
};
</script>

<style></style>
